
import React,{useState} from 'react';
import { FaSave } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import {Grid,Typography,TextField} from '@mui/material';
import CustomDialog from '../../../components/CustomDialog';
import SaveLoading from '../../../components/SaveLoading';

const PurchaseMixDialog = ({open, setOpen, handleSave, saveLoading, isMobile}) => {
    const [amount, setAmount] = useState(0);
    const [remark, setRemark] = useState("");

    const handleClear = () => {
        setAmount(0);
        setRemark("");
    }

    const handleInputChange = (value, type) => {
        if (type === "amount") {
            const numericValue = value === "" ? 0 : parseInt(value);
            if (isNaN(numericValue)) {
                return;
            }

            setAmount(numericValue);
        }
        else {
            setRemark(value);
        }
    }

    const handleCancel = () => {
        handleClear();
        setOpen(false);
    }

  return (
        <CustomDialog open={open} isMobile={isMobile}>
            { saveLoading &&
               <SaveLoading loading={saveLoading} />
            }
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <Typography>Amount</Typography>
                </Grid>
                <Grid item xs={8}>
                    <TextField size="small" label="Amount" value={amount} onChange={(e) => handleInputChange(e.target.value, 'amount')} />
                </Grid>
                <Grid item xs={4}>
                    <Typography>Remark</Typography>
                </Grid>
                <Grid item xs={8}>
                    <TextField size="small" label="Remark" value={remark} onChange={(e) => handleInputChange(e.target.value, 'remark')} />
                </Grid>
            </Grid>
            <div className='flex justify-center items-center gap-4 mt-2 text-[0.875rem]'>
                <div className='flex items-center gap-2'>
                    <button
                        onClick={() => handleSave(amount, remark, handleClear)}
                        className='flex items-center px-3 py-1 border border-customBorder rounded bg-customAccentBlue text-customBackColor'
                    >
                       
                    <FaSave className='mr-1' />
                         
                         Save
                    </button>
                </div>
                <div className='flex items-center gap-2'>
                    <button
                        className='flex items-center px-3 py-1 border border-customTitleColor rounded bg-customGray text-customInk dark:border-customBorder dark:bg-customSurfaceMuted dark:text-customWhite'
                        onClick={() => handleCancel()}
                    ><ImCross className='mr-1' />Cancel
                    </button>
                </div>
            </div>
      </CustomDialog>
  )
}

export default PurchaseMixDialog;
